import React, { FC, useEffect } from 'react'

import { Typography, FNOLPageWrapper, FNOLButton } from '@dg-shared'
import { useTranslate, useClaim } from '../../../hooks/shared'
import { CommonPageProps } from '../../../types/interface/fsm.interface'
import { Events } from '../../../FSM/shared/constants'
import { TRANSLATIONS as T, ClaimEventName, FNOL_COLLISION_QUESTIONS } from '../../../constants'
import { useFNOLStyles } from '../shared/styles/useStyles'

const PageAccidentForm: FC<CommonPageProps> = ({ service, currentState }) => {
  const { classes: FNOLClasses } = useFNOLStyles({})
  const { t } = useTranslate(`${T.COLLISION}.accidentForm`)
  const { handleAnswerClick, clearAnswer } = useClaim(service, currentState)

  useEffect(() => {
    clearAnswer(FNOL_COLLISION_QUESTIONS.HAVE_YOU_FILLED_FORM_PAPER)
  }, [clearAnswer])

  const itemSelect = ({ eventName, label, value }: ClaimEventName) => (
    <FNOLButton
      key={label}
      testId={label}
      handleClick={() =>
        handleAnswerClick(FNOL_COLLISION_QUESTIONS.HAVE_YOU_FILLED_FORM_PAPER, value, eventName)
      }
      buttonText={t(label)}
    />
  )

  const eventItems = [
    { eventName: Events.NEXT, label: 'button.yes', value: true },
    { eventName: Events.FNOL_ADDITIONAL_INFORMATION, label: 'button.no', value: false },
  ]
  const ItemsList = () => <>{eventItems.map((item) => itemSelect(item))}</>

  const Content = () => (
    <>
      <Typography testId='title' type='h1' className={FNOLClasses.title}>
        {t('title')}
      </Typography>
      <Typography testId='subtitle' html={true} className={FNOLClasses.description}>
        {t('subtitle')}
      </Typography>
      <ItemsList />
    </>
  )

  return (
    <FNOLPageWrapper breadcrumbsBtnText={t(`back`)} breadcrumbsStepPercentage={80}>
      <Content />
    </FNOLPageWrapper>
  )
}

export default PageAccidentForm
